import { render, staticRenderFns } from "./wordDown.vue?vue&type=template&id=0bcf81bd&scoped=true&"
import script from "./wordDown.vue?vue&type=script&lang=js&"
export * from "./wordDown.vue?vue&type=script&lang=js&"
import style0 from "./wordDown.vue?vue&type=style&index=0&id=0bcf81bd&lang=scss&scoped=true&"
import style1 from "./wordDown.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcf81bd",
  null
  
)

component.options.__file = "wordDown.vue"
export default component.exports